import { Spinner, Stack } from 'component-library';
import { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { SuspenseBoundary } from '@/components';
import { ErrorFallback } from '@/components/widgets/ErrorBoundary';
import { Logger } from '@/lib/logs/logger';

const WithErrorBoundary = ({
  name,
  children,
  errorFallBack,
}: {
  name?: string;
  children: ReactNode;
  errorFallBack?: ReactNode;
}) => {
  return (
    <ErrorBoundary
      FallbackComponent={({ error }) =>
        errorFallBack ? <>{errorFallBack}</> : <ErrorFallback title={name} error={error} />
      }
      onError={(error, info) => {
        Logger.error(
          name
            ? `Plot card rendering error (name: ${name}): ${error} ${info}`
            : `Plot card rendering error: ${error} ${info}`,
        );
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

const LoaderFallback = () => (
  <Stack centerMain>
    <Spinner size={10} />
  </Stack>
);

export const PlotCardWrapper = ({
  name,
  children,
  errorFallBack,
  loaderFallBack,
}: {
  name?: string;
  children: ReactNode;
  errorFallBack?: ReactNode;
  loaderFallBack?: ReactNode;
}) => {
  return (
    <WithErrorBoundary name={name} errorFallBack={errorFallBack}>
      <SuspenseBoundary fallback={loaderFallBack ? <>{loaderFallBack}</> : <LoaderFallback />}>
        {children}
      </SuspenseBoundary>
    </WithErrorBoundary>
  );
};
